module.exports = __webpack_public_path__ + "img/thumbnail_DromedaryCamel_j_albino.b4fccedd.png";